module.exports = __webpack_public_path__ + "static/media/check.2d9d4c82.svg";